import React from 'react';
import { createPortal } from 'react-dom';
import { useQuery } from 'react-query';
import { getCatalogStats } from '../../api/catalogLevels';
import { BookOpen, Heart, Send, UserCheck } from 'lucide-react';
import BookmarkIcon from '../Icons/BookmarkIcon';

const STAT_ITEMS = [
    { key: 'wall_posts', label: 'В гостевой', icon: BookOpen, color: 'text-purple-500' },
    { key: 'bookmarks', label: 'В избранном', icon: BookmarkIcon, color: 'text-amber-500', isBookmark: true },
    { key: 'total_likes', label: 'Лайков', icon: Heart, color: 'text-red-500' },
    { key: 'postcards_shared', label: 'Отправлено', icon: Send, color: 'text-blue-500' },
    { key: 'postcards_claimed', label: 'Принято людьми', icon: UserCheck, color: 'text-green-500' },
];

const StatsPopup = ({ onClose }) => {
    const { data: stats, isLoading } = useQuery(
        ['catalog-stats'],
        getCatalogStats,
        { staleTime: 30 * 1000 }
    );

    return createPortal(
        <div className="fixed inset-0 z-[9999] flex items-center justify-center" onClick={onClose}>
            <div className="absolute inset-0 bg-black/40" />
            <div
                className="relative bg-white dark:bg-gray-800 rounded-2xl p-5 mx-4 max-w-[320px] w-full shadow-2xl animate-fade-in"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="text-center mb-4">
                    <span className="text-3xl">☀️</span>
                    <div className="text-lg font-bold text-gray-900 dark:text-gray-100 mt-1">Моя статистика</div>
                </div>

                {isLoading ? (
                    <div className="text-center text-gray-400 py-4">Загрузка...</div>
                ) : stats ? (
                    <div className="grid grid-cols-2 gap-3 mb-4">
                        {STAT_ITEMS.map(({ key, label, icon: Icon, color, isBookmark }) => (
                            <div key={key} className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-3 text-center">
                                <div className="flex justify-center mb-1">
                                    {isBookmark ? (
                                        <BookmarkIcon size={18} className={color} />
                                    ) : (
                                        <Icon size={18} className={color} />
                                    )}
                                </div>
                                <div className="text-xl font-bold text-gray-900 dark:text-gray-100">
                                    {stats[key] || 0}
                                </div>
                                <div className="text-[10px] text-gray-500 dark:text-gray-400 leading-tight">
                                    {label}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}

                <button
                    onClick={onClose}
                    className="w-full py-2 text-sm font-semibold rounded-xl text-blue-500 dark:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
                >
                    Закрыть
                </button>
                {typeof __BUILD_TIME__ !== 'undefined' && (
                    <div className="text-center text-[9px] text-gray-300 dark:text-gray-600 mt-2">
                        v{__BUILD_TIME__.slice(0, 16).replace('T', ' ')}
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
};

export default StatsPopup;
